import { useCallback, useState } from 'react';

const STORAGE_KEY = 'Assistant.novaVoiceDisclaimerLastSeen';
const ONE_WEEK_IN_MS = 7 * 24 * 60 * 60 * 1000;

function shouldShowVoiceDisclaimer(): boolean {
  const lastSeen = localStorage.getItem(STORAGE_KEY);
  if (!lastSeen) {
    return true;
  }

  const parsed = Date.parse(lastSeen);
  if (isNaN(parsed)) {
    return true;
  }

  return Date.now() - parsed > ONE_WEEK_IN_MS;
}

type ShowVoiceDisclaimerResult = {
  showVoiceDisclaimer: boolean;
  acknowledge(): void;
};

export function useShowVoiceDisclaimer(): ShowVoiceDisclaimerResult {
  const [state, setState] = useState<
    Omit<ShowVoiceDisclaimerResult, 'acknowledge'>
  >({
    showVoiceDisclaimer: shouldShowVoiceDisclaimer(),
  });

  const acknowledge = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    setState({ showVoiceDisclaimer: false });
  }, []);

  return { ...state, acknowledge };
}
